import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getUrl } from '../../App';
import styles from './EventCard.module.css';
import robocup_img from '@shared/assets/robocup.jpeg';
import { PenLine } from "lucide-react"
import { Button } from "@shared/components/ui/button"
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@shared/components/ui/dialog"
import { Input } from "@shared/components/ui/input"
import { Label } from "@shared/components/ui/label"

const update_event = async ({ id, name, event_folder, country}) => {

    const response = await fetch(`${getUrl()}/api/events/${id}/`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
            name,
            event_folder,
            country,
        })
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
}


export const EventCard = ({ event }) => {
    const navigate = useNavigate();

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const queryClient = useQueryClient();

    const updateEventMutation = useMutation({
        mutationFn: update_event,
        onSuccess: () => {

            queryClient.invalidateQueries({ queryKey: ['events'] });
            setIsDialogOpen(false);
        },
        onError: (error) => {
            console.error("Failed to update event:", error);
        }
    });

    const onSubmit = (e) => {
        const form = e.currentTarget.form;
        if (!form) return;

        const formData = new FormData(form);

        updateEventMutation.mutate({
            id: event.id,
            name: formData.get("name"),
            event_folder: formData.get("folder"),
            country: formData.get("country"),
        });
    };

    return (
        <div className={styles.event_card}>
            <div className={styles.event_header} onClick={() => navigate(`/events/${event.id}`)}>
                <img src={robocup_img} alt="RoboCup Image" />
            </div>
            <div className={styles.event_content}>
                <p className={styles.event_title}>
                    Event: {event.name}
                </p>
                <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
                    <DialogTrigger asChild>
                        <PenLine className="cursor-pointer" />
                    </DialogTrigger>
                    <DialogContent className={styles.event_card}>
                        <DialogHeader>
                            <DialogTitle className={styles.dialog_title}>Update Event</DialogTitle>
                        </DialogHeader>

                        <form key={JSON.stringify(event)} className="flex flex-col gap-4">

                            <div className={styles.form_group}>
                                <label htmlFor="name">Name:</label>
                                <input type="text" id="name" name="name" defaultValue={event.name} />
                            </div>

                            <div className={styles.form_group}>
                                <label htmlFor="folder">Folder:</label>
                                <input type="text" id="folder" name="folder" defaultValue={event.event_folder} />
                            </div>

                            <div className={styles.form_group}>
                                <label htmlFor="country">Country:</label>
                                <input type="text" id="country" name="country" defaultValue={event.country} />
                            </div>

                            <DialogFooter className="sm:justify-start">

                                <DialogClose asChild>
                                    <Button className={styles.form_group} variant="secondary" type="button" disabled={updateEventMutation.isLoading} onClick={onSubmit}>
                                        {updateEventMutation.isLoading ? 'Saving...' : 'Save & Close'}
                                    </Button>
                                </DialogClose>

                                <Button type="button" variant="secondary">
                                    Close
                                </Button>

                            </DialogFooter>
                        </form>

                    </DialogContent>
                </Dialog>

            </div>
            <div className={styles.event_footer}>

            </div>
        </div>
    );
};

export const CreateEventCard = () => {
    return (
        <div className={styles.event_card}>
            <div className={styles.event_header}>
                <img src={robocup_img} alt="RoboCup Image" />
            </div>
            <div className={styles.event_content}>
                <Dialog>
                    <DialogTrigger asChild>
                        <Button variant="outline">Share</Button>
                    </DialogTrigger>
                    <DialogContent className="sm:max-w-md">
                        <DialogHeader>
                            <DialogTitle>Share link</DialogTitle>
                            <DialogDescription>
                                Anyone who has this link will be able to view this.
                            </DialogDescription>
                        </DialogHeader>
                        <div className="flex items-center gap-2">
                            <div className="grid flex-1 gap-2">
                                <Label htmlFor="link" className="sr-only">
                                    Link
                                </Label>
                                <Input
                                    id="link"
                                    defaultValue="https://ui.shadcn.com/docs/installation"
                                    readOnly
                                />
                            </div>
                        </div>
                        <DialogFooter className="sm:justify-start">
                            <DialogClose asChild>
                                <Button type="button" variant="secondary">
                                    Close
                                </Button>
                            </DialogClose>
                        </DialogFooter>
                    </DialogContent>
                </Dialog>
            </div>
            <div className={styles.event_footer}>

            </div>
        </div>
    );
};
